import { render } from "./DeliveryZone.vue?vue&type=template&id=b8e87798"
import script from "./DeliveryZone.vue?vue&type=script&lang=js"
export * from "./DeliveryZone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__